export const RETURNS_PERIODS = ['pnlPercent180t', 'pnlPercent90t'];
export const DEFAULT_PERIOD = 'pnlPercent180t';
export const SERVICES_COINS = ['USDT', 'USDC', 'BNB', 'ETH', 'BTC'];
